import { Fragment, memo } from "react";
import { Division, Flex, TabPanel, Tabs } from "@ir/ui";
import { useCredit, useDeductionDrawer } from "@/presentation/deduction/hooks";
import { CreditTabType } from "@/store/credit/credit.atoms";
import { CreditInformation } from "./CreditInformation";
import { CreditDocuments } from "./CreditDocuments";
import CreditFetchingError from "./CreditFetchingError";
import CreditTabList from "./CreditDrawerTabs/TabList";
import DeductionDocumentViewer from "../DeductionInformation/DeductionDocumentViewer";

const CreditContent = memo(() => {
  const { credit, isLoading, error, selectedTab, setSelectedTab } = useCredit();
  const { isDocumentViewerOpen, viewerDocuments, drawerInfo, isDrawerModal } = useDeductionDrawer();

  const renderCreditContent = () => {
    if (error) {
      return <CreditFetchingError creditError={error} />;
    }

    return (
      <Fragment>
        <CreditInformation credit={credit} isLoading={isLoading} />
        <CreditDocuments credit={credit} isLoading={isLoading} />
      </Fragment>
    );
  };

  return (
    <Flex direction="row" align="stretch" justifyContent="end">
      <Tabs
        orientation="horizontal"
        aria-label="Credits list"
        style={{ height: "100%", width: isDocumentViewerOpen && isDrawerModal ? "50%" : "100%" }}
        keyboardActivation="manual"
        selectedKey={selectedTab ?? CreditTabType.INFORMATION}
        onSelectionChange={key => {
          setSelectedTab(key as CreditTabType);
        }}
      >
        <Division className="bg-white border-bottom-1 border-color-grey-50 px-4">
          <Flex justifyContent="space-between" align="center" style={{ marginBottom: "-1px" }}>
            <CreditTabList />
          </Flex>
        </Division>
        <Division className="flex flex-1 flex-align-start">
          <TabPanel
            id={CreditTabType.INFORMATION}
            role="tabpanel"
            aria-label={CreditTabType.INFORMATION}
            className="flex-1 w-100 p-4"
            style={{ height: "calc(100vh - 115px)", overflow: "auto" }}
          >
            <Division className="Information-Drawer-Content w-100">{renderCreditContent()}</Division>
          </TabPanel>
        </Division>
      </Tabs>

      {isDocumentViewerOpen && viewerDocuments && drawerInfo?.invoiceNumber && (
        <DeductionDocumentViewer
          className="open-document-viewer"
          documents={viewerDocuments}
          invoiceNumber={drawerInfo.invoiceNumber}
        />
      )}
    </Flex>
  );
});

CreditContent.displayName = "CreditContent";

export default CreditContent;
